<template>
    <div class="upload-data">
        <div :class="{ 'upload-data-inner': true, 'upload-data-inner-stopscroll': isStopScroll }">
            <!-- 营业执照 -->
            <div class="business-license each-upload">
                <div class="upload-data-content-title">
                    <span class="color-red">*</span>{{ $t('营业执照') }}<span
                        class="color-gray upload-data-content-title-limitdesc">{{ $t('（2M以内，支持png、jpg、jpeg格式）') }}</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        :inner-desc="$t('点击选择或拖动文件到此区域')" :upload-id="0" />
                </div>
                <div class="four-factor-form business-license-form">
                    <v-form kind="inline" size="small">
                        <v-form-item label="统一社会信用代码" name="creditCode">
                            <template slot="label">
                                <span class="four-factor-form-required" aria-hidden="true">*</span>统一社会信用代码
                            </template>
                            <v-input v-model.trim="fourFactorForm.creditCode" placeholder="上传营业执照后自动识别，可手动修改"
                                :class="{ 'is-invalid': !!fieldTipError.creditCode }" aria-label="统一社会信用代码"
                                aria-required="true" autocomplete="off"
                                @input="handleFieldInput('creditCode', $event)" @focus="handleFieldFocus('creditCode')"
                                @blur="handleFieldBlur('creditCode')" />
                            <span v-if="ocrLoading.businessLicense" class="four-factor-form-wait" role="status"
                                aria-live="polite">
                                <i class="four-factor-form-wait-icon" />识别中
                            </span>
                            <span v-if="fieldTipError.creditCode" class="four-factor-form-error" role="alert">
                                {{ fieldTipError.creditCode }}
                            </span>
                        </v-form-item>
                    </v-form>
                    <div v-if="ocrNotice.businessLicense" class="four-factor-form-status" role="status" aria-live="polite">
                        {{ ocrNotice.businessLicense }}
                    </div>
                </div>
            </div>
            <!-- 法人身份证 -->
            <div class="id-card each-upload">
                <div class="upload-data-content-title">
                    <span class="color-red">*</span>{{ $t('法人身份证') }}<span
                        class="color-gray upload-data-content-title-limitdesc">{{ $t('（2M以内，支持png、jpg、jpeg格式）') }}</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        :inner-desc="$t('点击选择或拖动文件到此区域')" :frame-desc="$t('身份证国徽面照片')" :upload-id="1" />
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        :inner-desc="$t('点击选择或拖动文件到此区域')" :frame-desc="$t('身份证头像面照片')" :upload-id="2" />
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        :inner-desc="$t('点击选择或拖动文件到此区域')" :frame-desc="$t('法人手持身份证头像面照片')" :upload-id="3" />
                </div>
                <div class="four-factor-form id-card-form">
                    <v-form kind="inline" size="small">
                        <v-form-item label="姓名" name="legalPersonName">
                            <template slot="label">
                                <span class="four-factor-form-required" aria-hidden="true">*</span>姓名
                            </template>
                            <v-input v-model.trim="fourFactorForm.legalPersonName" placeholder="上传身份证头像面后自动识别，可手动修改"
                                :class="{ 'is-invalid': !!fieldTipError.legalPersonName }" aria-label="法人姓名"
                                aria-required="true" autocomplete="off"
                                @input="handleFieldInput('legalPersonName', $event)"
                                @focus="handleFieldFocus('legalPersonName')" @blur="handleFieldBlur('legalPersonName')" />
                            <span v-if="ocrLoading.idCardFront" class="four-factor-form-wait" role="status"
                                aria-live="polite">
                                <i class="four-factor-form-wait-icon" />识别中
                            </span>
                            <span v-if="fieldTipError.legalPersonName" class="four-factor-form-error" role="alert">
                                {{ fieldTipError.legalPersonName }}
                            </span>
                        </v-form-item>
                    </v-form>
                    <v-form kind="inline" size="small">
                        <v-form-item label="身份证号" name="legalPersonIdNo">
                            <template slot="label">
                                <span class="four-factor-form-required" aria-hidden="true">*</span>身份证号
                            </template>
                            <v-input v-model.trim="fourFactorForm.legalPersonIdNo" placeholder="上传身份证头像面后自动识别，可手动修改"
                                :class="{ 'is-invalid': !!fieldTipError.legalPersonIdNo }" aria-label="法人身份证号"
                                aria-required="true" autocomplete="off"
                                @input="handleFieldInput('legalPersonIdNo', $event)"
                                @focus="handleFieldFocus('legalPersonIdNo')" @blur="handleFieldBlur('legalPersonIdNo')" />
                            <span v-if="ocrLoading.idCardFront" class="four-factor-form-wait" role="status"
                                aria-live="polite">
                                <i class="four-factor-form-wait-icon" />识别中
                            </span>
                            <span v-if="fieldTipError.legalPersonIdNo" class="four-factor-form-error" role="alert">
                                {{ fieldTipError.legalPersonIdNo }}
                            </span>
                        </v-form-item>
                    </v-form>
                    <div v-if="ocrNotice.idCardFront" class="four-factor-form-status" role="status" aria-live="polite">
                        {{ ocrNotice.idCardFront }}
                    </div>
                </div>
            </div>
            <!-- 变更申请表 -->
            <div class="application each-upload">
                <div class="upload-data-content-title">
                    <span class="color-red">*</span>{{ $t('变更申请表') }}
                    <a
                        href="https://corpverify-30042.sz.gfp.tencent-cloud.com/corp/2852199327/107/corp-2852199327-107-1629274976.pdf">{{ $t('下载变更申请表') }}</a>
                    <span class="color-gray upload-data-content-title-limitdesc">{{ $t('（2M以内，支持png、jpg、jpeg格式）') }}</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        :inner-desc="$t('点击选择或拖动文件到此区域')" :frame-desc="$t('变更申请表照片')" :upload-id="4" />
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        :inner-desc="$t('点击选择或拖动文件到此区域')" :frame-desc="$t('法人手持变更申请表照片')" :upload-id="5" />
                </div>
            </div>
            <!-- 补充资质附件 -->
            <div class="supplement each-upload">
                <div class="upload-data-content-title">
                    {{ $t('补充资质附件') }}<span class="color-gray upload-data-content-title-limitdesc">{{ $t('（2M以内，支持png、jpg、jpeg格式）') }}</span>
                </div>
                <div class="flex-box">
                    <uploadFrame :is-click-submit="isClickSubmit" :upload-arr="uploadArr" :upload-url="uploadUrl"
                        :inner-desc="$t('点击选择或拖动文件到此区域')" frame-desc="" :upload-id="6" />
                </div>
            </div>
        </div>
        <div class="upload-data-bottom">
            <v-button status="default" size="large" :disabled="submitLoading" @click="previousStep">
                {{ $t('上一步') }}
            </v-button>
            <v-button status="primary" size="large" style="margin:0 20px" :loading="submitLoading"
                @click="submitFile">
                {{ $t('提交') }}
            </v-button>
            <v-button status="default" size="large" :disabled="submitLoading" @click="cancel">
                {{ $t('取消') }}
            </v-button>
        </div>
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import uploadFrame from './uploadFrame.vue';

const OCR_URL = '/v1/boss/audit/card_ocr';
const OCR_TIMEOUT = 10000;
const OCR_CONFIG = {
    businessLicense: {
        uploadId: 0,
        cardType: 0,
        fields: ['creditCode'],
        normalizeResult: (data) => {
            const businessLicense = data && (data.biz_license || data.bis_license);
            return {
                creditCode: businessLicense && businessLicense.credit_code,
            };
        },
    },
    idCardFront: {
        uploadId: 2,
        cardType: 1,
        fields: ['legalPersonName', 'legalPersonIdNo'],
        normalizeResult: data => ({
            legalPersonName: data && data.id_card && data.id_card.name,
            legalPersonIdNo: data && data.id_card && data.id_card.id_number,
        }),
    },
};
// 四要素中的可编辑字段
const FOUR_FACTOR_FIELDS = ['creditCode', 'legalPersonName', 'legalPersonIdNo'];
// 前端校验文案：必填提示
const REQUIRED_ERROR_TEXT = '请检查是否有必填项未填';
// 前端校验文案：格式错误提示
const FORMAT_ERROR_TEXT = {
    creditCode: '统一社会信用代码格式有误，请检查',
    legalPersonIdNo: '身份证号格式有误，请检查',
};
// 统一社会信用代码弱校验：仅数字与英文字母，长度 18；校验位与真实性交由后台核验
const CREDIT_CODE_PATTERN = /^[0-9A-Z]{18}$/;
// 后台人企四要素核验失败时的字段定位规则，按顺序匹配后台返回文案
// 用于把“格式正确但核验不通过”的后台结论展示到对应编辑框下方
const BACKEND_FIELD_ERROR_RULES = [
    {
        field: 'legalPersonIdNo',
        pattern: /身份证/,
        message: '法人身份证信息不一致，请确认',
    },
    {
        field: 'creditCode',
        pattern: /信用代码|营业执照号/,
        message: '统一社会信用代码有误，请确认',
    },
    {
        field: 'legalPersonName',
        pattern: /法人姓名|法定代表人|法人名称/,
        message: '法人姓名信息不一致，请确认',
    },
];

export default {
    components: {
        uploadFrame,
    },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        newQQ: {
            type: String,
            default: '',
        },
        newPhone: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            uploadArr: {
                0: {},
                1: {},
                2: {},
                3: {},
                4: {},
                5: {},
                6: {},
            },
            fourFactorForm: {
                creditCode: '',
                legalPersonName: '',
                legalPersonIdNo: '',
            },
            fieldSource: {
                creditCode: 'empty',
                legalPersonName: 'empty',
                legalPersonIdNo: 'empty',
            },
            // 前端校验错误文案，展示在对应编辑框下方
            fieldError: {
                creditCode: '',
                legalPersonName: '',
                legalPersonIdNo: '',
            },
            // 后台核验失败错误文案，与前端校验错误分开存放，便于定位问题来源
            backendFieldError: {
                creditCode: '',
                legalPersonName: '',
                legalPersonIdNo: '',
            },
            // 聚焦瞬间的值快照，用于判断用户是否主动修改过内容
            fieldFocusValue: {
                creditCode: '',
                legalPersonName: '',
                legalPersonIdNo: '',
            },
            // 编辑框是否处于聚焦态，用于区分用户输入与程序化赋值
            fieldFocused: {
                creditCode: false,
                legalPersonName: false,
                legalPersonIdNo: false,
            },
            // 最近一次程序化写入的值，用于过滤 v-input 回抛的 input 事件
            programmaticValue: {
                creditCode: null,
                legalPersonName: null,
                legalPersonIdNo: null,
            },
            ocrLoading: {
                businessLicense: false,
                idCardFront: false,
            },
            ocrLimited: {
                businessLicense: false,
                idCardFront: false,
            },
            ocrNotice: {
                businessLicense: '',
                idCardFront: '',
            },
            ocrRequestVersion: {
                businessLicense: 0,
                idCardFront: 0,
            },
            ocrRequestUrl: {
                businessLicense: '',
                idCardFront: '',
            },
            ocrTimeoutTimer: {
                businessLicense: null,
                idCardFront: null,
            },
            isClickSubmit: false,
            uploadUrl: '/mng/account/contacts/uploadContactImg',
            submitUrl: '/mng/account/contacts/updateAdminContact',
            isStopScroll: false,
            submitLoading: false,
        };
    },
    computed: {
        /**
         * 编辑框下方最终展示的错误文案，前端校验错误优先于后台核验错误
         * @return {Object} 字段名到错误文案的映射
         */
        fieldTipError() {
            return FOUR_FACTOR_FIELDS.reduce((result, field) => {
                result[field] = this.fieldError[field] || this.backendFieldError[field];
                return result;
            }, {});
        },
    },
    beforeDestroy() {
        this.invalidateOcrRequests();
    },
    methods: {
        previousStep() {
            if (this.submitLoading) return;
            this.invalidateOcrRequests();
            this.$parent.$parent.clickPreviousStep();
        },
        cancel() {
            if (this.submitLoading) return;
            this.invalidateOcrRequests();
            this.$parent.$parent.cancel();
        },
        changeUploadArr(uploadId, file) {
            const previousFile = this.uploadArr[uploadId];
            this.$set(this.uploadArr, uploadId, file);
            if (uploadId === OCR_CONFIG.businessLicense.uploadId) {
                this.handleOcrUpload('businessLicense', file, previousFile);
            }
            if (uploadId === OCR_CONFIG.idCardFront.uploadId) {
                this.handleOcrUpload('idCardFront', file, previousFile);
            }
        },
        handleOcrUpload(type, file, previousFile) {
            if (typeof file !== 'string' || !file) {
                this.clearOcrFields(type, true);
                return;
            }
            if (file !== previousFile) {
                this.clearOcrFields(type);
            }
            if (this.ocrLimited[type]) {
                this.setOcrNotice(type, '用户核验次数超限，请明天再试');
                return;
            }
            if (this.ocrLoading[type] && this.ocrRequestUrl[type] === file) return;
            this.requestOcr(type, file);
        },
        requestOcr(type, fileUrl) {
            const config = OCR_CONFIG[type];
            const version = this.ocrRequestVersion[type] + 1;
            this.$set(this.ocrRequestVersion, type, version);
            this.$set(this.ocrRequestUrl, type, fileUrl);
            this.$set(this.ocrLoading, type, true);
            this.setOcrNotice(type, '');
            this.clearOcrTimeout(type);
            this.$set(this.ocrTimeoutTimer, type, setTimeout(() => {
                this.handleOcrTimeout(type, version, fileUrl);
            }, OCR_TIMEOUT));
            return Gateway.post(OCR_URL, {
                card_type: config.cardType,
                image_url: fileUrl,
            }, {
                errLevel: 1,
            }).then((data) => {
                if (!this.isCurrentOcrRequest(type, version, fileUrl)) return;
                const result = config.normalizeResult(data);
                this.fillOcrFields(type, result);
                if (config.fields.some(field => !result[field] && !this.fourFactorForm[field])) {
                    this.setOcrNotice(type, '部分信息未识别，请手动补全');
                }
            })
            .catch((error) => {
                if (this.isCurrentOcrRequest(type, version, fileUrl)) {
                    this.handleOcrRequestError(type, error);
                }
            })
            .then(() => {
                if (this.isCurrentOcrRequest(type, version, fileUrl)) {
                    this.clearOcrTimeout(type);
                    this.$set(this.ocrLoading, type, false);
                    this.$set(this.ocrRequestUrl, type, '');
                }
            });
        },
        handleOcrTimeout(type, version, fileUrl) {
            if (!this.isCurrentOcrRequest(type, version, fileUrl)) return;
            this.$set(this.ocrRequestVersion, type, version + 1);
            this.$set(this.ocrLoading, type, false);
            this.$set(this.ocrRequestUrl, type, '');
            this.clearOcrTimeout(type);
            const message = '识别超时，请手动填写或重新上传图片';
            this.setOcrNotice(type, message);
            this.$message.error(message);
        },
        clearOcrTimeout(type) {
            if (!this.ocrTimeoutTimer[type]) return;
            clearTimeout(this.ocrTimeoutTimer[type]);
            this.$set(this.ocrTimeoutTimer, type, null);
        },
        handleOcrRequestError(type, error) {
            const message = this.getOcrErrorMessage(error) || '识别失败，请手动填写';
            if (this.isOcrLimited(message)) {
                this.$set(this.ocrLimited, type, true);
            }
            this.setOcrNotice(type, message);
            this.$message.error(message);
        },
        getOcrErrorMessage(error) {
            if (typeof error === 'string') return error;
            if (!error) return '';
            if (error.message || error.msg) return error.message || error.msg;
            const data = error.data || {};
            return data.message || data.msg || '';
        },
        isOcrLimited(message) {
            return /(?:核验)?次数.*超限|请明天再试/.test(message);
        },
        setOcrNotice(type, message) {
            this.$set(this.ocrNotice, type, message);
        },
        isCurrentOcrRequest(type, version, fileUrl) {
            return this.ocrRequestVersion[type] === version
                && this.uploadArr[OCR_CONFIG[type].uploadId] === fileUrl;
        },
        fillOcrFields(type, data) {
            OCR_CONFIG[type].fields.forEach((field) => {
                if (!data[field] || this.fieldSource[field] === 'manual') return;
                this.setFieldValue(field, String(data[field]), 'ocr');
            });
        },
        clearOcrFields(type, forceClear = false) {
            this.$set(this.ocrRequestVersion, type, this.ocrRequestVersion[type] + 1);
            this.$set(this.ocrLoading, type, false);
            this.$set(this.ocrRequestUrl, type, '');
            this.clearOcrTimeout(type);
            this.setOcrNotice(type, '');
            OCR_CONFIG[type].fields.forEach((field) => {
                if (!forceClear && this.fieldSource[field] !== 'ocr') return;
                this.setFieldValue(field, '', 'empty');
            });
        },
        invalidateOcrRequests() {
            Object.keys(this.ocrRequestVersion).forEach((type) => {
                this.$set(this.ocrRequestVersion, type, this.ocrRequestVersion[type] + 1);
                this.$set(this.ocrLoading, type, false);
                this.$set(this.ocrRequestUrl, type, '');
                this.clearOcrTimeout(type);
            });
        },
        /**
         * 程序化写入字段值（OCR 回填、删除清空、提交前归一化）
         * 同时记录本次写入值，避免 v-input 回抛的 input 事件被误判为用户手动输入
         * @param {string} field 字段名
         * @param {string} value 字段值
         * @param {string} [source] 字段来源，不传表示保持原有来源
         * @return {void}
         */
        setFieldValue(field, value, source) {
            this.$set(this.fourFactorForm, field, value);
            this.$set(this.programmaticValue, field, value);
            if (source) {
                this.$set(this.fieldSource, field, source);
            }
            this.clearFieldError(field);
        },
        /**
         * 编辑框输入事件
         * v-input 在 value 被程序改写时同样会抛出 input 事件，需要排除，
         * 否则删除照片清空字段或 OCR 回填都会被标记为 manual，导致后续 OCR 结果不再回填
         * @param {string} field 字段名
         * @param {string} value 输入框当前值
         * @return {void}
         */
        handleFieldInput(field, value) {
            const currentValue = typeof value === 'string' ? value.trim() : value;
            // 未聚焦，或与最近一次程序化写入值一致，说明不是用户手动输入
            if (!this.fieldFocused[field] || currentValue === this.programmaticValue[field]) return;
            this.$set(this.programmaticValue, field, null);
            this.$set(this.fieldSource, field, 'manual');
            // 输入过程中先清除旧提示，失焦时重新判定
            this.clearFieldError(field);
        },
        /**
         * 编辑框获得焦点，记录聚焦态与当前值快照
         * @param {string} field 字段名
         * @return {void}
         */
        handleFieldFocus(field) {
            this.$set(this.fieldFocused, field, true);
            this.$set(this.fieldFocusValue, field, this.fourFactorForm[field]);
        },
        /**
         * 编辑框失去焦点，仅在用户主动修改过内容时校验该字段
         * @param {string} field 字段名
         * @return {void}
         */
        handleFieldBlur(field) {
            this.$set(this.fieldFocused, field, false);
            const currentValue = this.fourFactorForm[field];
            if (currentValue === this.fieldFocusValue[field]) return;
            this.$set(this.fieldFocusValue, field, currentValue);
            this.validateField(field);
        },
        /**
         * 设置前端校验错误文案
         * @param {string} field 字段名
         * @param {string} message 错误文案，空字符串表示清除
         * @return {void}
         */
        setFieldError(field, message) {
            this.$set(this.fieldError, field, message || '');
        },
        /**
         * 清除某个字段的前端校验错误与后台核验错误
         * @param {string} field 字段名
         * @return {void}
         */
        clearFieldError(field) {
            this.$set(this.fieldError, field, '');
            this.$set(this.backendFieldError, field, '');
        },
        /**
         * 清除全部字段的后台核验错误
         * @return {void}
         */
        clearBackendFieldError() {
            FOUR_FACTOR_FIELDS.forEach((field) => {
                this.$set(this.backendFieldError, field, '');
            });
        },
        isUploadCompleted() {
            const noUploadArr = [];
            for (const key in this.uploadArr) {
                if (Object.keys(this.uploadArr[key]).length === 0 && noUploadArr.indexOf(key) === -1) {
                    noUploadArr.push(key);
                }
            }

            return (noUploadArr.length === 1 && noUploadArr[0] === '6') || !noUploadArr.length;
        },
        isValidIdNumber(value) {
            let year;
            let month;
            let day;
            if (/^\d{15}$/.test(value)) {
                year = Number(`19${value.slice(6, 8)}`);
                month = Number(value.slice(8, 10));
                day = Number(value.slice(10, 12));
                return this.isValidBirthday(year, month, day);

            }
            if (!/^\d{17}[\dX]$/.test(value)) return false;
            year = Number(value.slice(6, 10));
            month = Number(value.slice(10, 12));
            day = Number(value.slice(12, 14));
            if (!this.isValidBirthday(year, month, day)) return false;
            const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
            const sum = value.slice(0, 17).split('')
                .reduce((total, char, index) => total + Number(char) * weights[index], 0);
            return checkCodes[sum % 11] === value.charAt(17);
        },
        isValidBirthday(year, month, day) {
            const birthday = new Date(year, month - 1, day);
            return birthday.getFullYear() === year
                && birthday.getMonth() === month - 1
                && birthday.getDate() === day;
        },
        /**
         * 统一社会信用代码弱校验：仅做字符集（数字与英文字母）与长度校验
         * 校验位、真实性等交由后台核验后返回
         * @param {string} value 大写后的统一社会信用代码
         * @return {boolean} 是否通过前端校验
         */
        isValidCreditCode(value) {
            return CREDIT_CODE_PATTERN.test(value);
        },
        /**
         * 获取单个字段的前端校验错误文案
         * @param {string} field 字段名
         * @return {string} 错误文案，空字符串表示通过
         */
        getFieldErrorMessage(field) {
            const value = (this.fourFactorForm[field] || '').trim();
            if (!value) return REQUIRED_ERROR_TEXT;
            if (field === 'creditCode' && !this.isValidCreditCode(value.toUpperCase())) {
                return FORMAT_ERROR_TEXT.creditCode;
            }
            if (field === 'legalPersonIdNo' && !this.isValidIdNumber(value.toUpperCase())) {
                return FORMAT_ERROR_TEXT.legalPersonIdNo;
            }
            return '';
        },
        /**
         * 校验单个字段并把错误展示到对应编辑框下方
         * @param {string} field 字段名
         * @return {boolean} 是否通过校验
         */
        validateField(field) {
            const message = this.getFieldErrorMessage(field);
            this.setFieldError(field, message);
            // 内容已变化，上一次后台核验结论不再适用
            this.$set(this.backendFieldError, field, '');
            return !message;
        },
        /**
         * 提交前校验全部可编辑字段，一次性标出所有错误
         * @return {boolean} 是否全部通过校验
         */
        validateFourFactor() {
            const invalidFields = FOUR_FACTOR_FIELDS.filter(field => !this.validateField(field));
            if (invalidFields.length) return false;
            this.setFieldValue('creditCode', this.fourFactorForm.creditCode.trim().toUpperCase());
            this.setFieldValue('legalPersonName', this.fourFactorForm.legalPersonName.trim());
            this.setFieldValue('legalPersonIdNo', this.fourFactorForm.legalPersonIdNo.trim().toUpperCase());
            return true;
        },
        /**
         * 把后台人企四要素核验失败的结论定位到对应编辑框下方
         * @param {string} message 后台返回的纯文本提示
         * @return {boolean} 是否已定位到具体字段
         */
        mapBackendErrorToField(message) {
            if (!message) return false;
            const matchedRules = BACKEND_FIELD_ERROR_RULES.filter(rule => rule.pattern.test(message));
            if (!matchedRules.length) return false;
            matchedRules.forEach((rule) => {
                this.$set(this.backendFieldError, rule.field, rule.message);
            });
            return true;
        },
        submitFile() {
            if (this.submitLoading) return;
            this.isClickSubmit = true;
            this.clearBackendFieldError();
            const isUploadCompleted = this.isUploadCompleted();
            const isFourFactorValid = this.validateFourFactor();
            if (!isUploadCompleted || !isFourFactorValid) return;
            this.submitLoading = true;
            this.$ajax.post(this.submitUrl, {
                oldAdminQQ: this.contact.admin_qq,
                newAdminQQ: this.newQQ,
                oldPhone: this.contact.mobile,
                newPhone: this.newPhone,
                businessLicense: this.uploadArr[0] || '',
                legalPersonLicenceFront: this.uploadArr[1] || '',
                legalPersonLicenceBack: this.uploadArr[2] || '',
                legalPersonLicenceHold: this.uploadArr[3] || '',
                apply: this.uploadArr[4] || '',
                applyHold: this.uploadArr[5] || '',
                othorAttachment: this.uploadArr[6] || '',
                creditCode: this.fourFactorForm.creditCode,
                legalPerson: this.fourFactorForm.legalPersonName,
                legalPersonIdNum: this.fourFactorForm.legalPersonIdNo,
            }, {
                customFn: (res) => {
                    this.submitLoading = false;
                    const message = (res && (res.message || res.msg)) || '';
                    // 人企四要素核验失败时定位到对应编辑框，未命中字段的错误仍走全局提示
                    if (this.mapBackendErrorToField(message)) return;
                    this.$message.error(message || this.$t('提交失败'));
                },
            }).then((res) => {
                if (!res || res.code !== 0) return;
                this.$message.success(this.$t('提交成功'));
                this.closePanel();
                window.location.reload();
            })
            .catch(() => {
                this.$message.error(this.$t('提交失败，请稍后重试'));
            })
            .finally(() => {
                this.submitLoading = false;
            });
        },
        closePanel() {
            this.invalidateOcrRequests();
            this.$parent.$parent.cancel(true);
        },
        stopScrollControl(status) {
            this.isStopScroll = status;
        },
    },
};
</script>

<style lang="less" scoped>
.upload-data {
    width: 472px;
    overflow-x: hidden;
}

.color-red {
    color: #FF4222;
}

.color-gray {
    color: #A8ABB3;
}

.upload-data-inner {
    max-height: 444px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0 0 30px 4px;

    &-stopscroll {
        overflow-y: hidden;
    }
}

.upload-data-content-title {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 1;
    text-align: left;
    margin: 8px 0;

    &-limitdesc {
        font-size: 12px;
        line-height: 17px;
    }
}

.upload-data-bottom {
    width: 100%;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.each-upload:first-child {
    padding-top: 12px;
}

.each-upload {
    padding-top: 23px;
}

.flex-box {
    display: flex;
}

.four-factor-form {
    margin-top: 12px;

    /deep/ .v-form__inline {
        line-height: normal;
    }

    /deep/ .v-form-item {
        display: flex;
        align-items: flex-start;
        float: none;
        margin-bottom: 12px;
    }

    /deep/ .v-form-item__label {
        display: inline-flex;
        align-items: center;
        float: none;
        margin-right: 12px;
        height: 32px;
        line-height: 32px;
        text-align: left;
        white-space: nowrap;
    }

    /deep/ .v-form-item__input {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        float: none;
    }

    /deep/ .v-input {
        width: 242px;
    }

    /* 错误文案：独占一行，换行到编辑框下方展示 */
    &-error {
        flex: 0 0 100%;
        margin-top: 4px;
        color: #FF4222;
        font-size: 12px;
        line-height: 17px;
        text-align: left;
    }

    &-wait {
        display: inline-flex;
        align-items: center;
        margin-left: 8px;
        color: #A8ABB3;
        font-size: 12px;
        line-height: 20px;
        white-space: nowrap;
    }

    &-wait-icon {
        width: 12px;
        height: 12px;
        margin-right: 4px;
        border: 1px solid #D5D9E1;
        border-top-color: #2B7AF3;
        border-radius: 50%;
        animation: ocr-wait-rotate 0.8s linear infinite;
    }

    &-required {
        display: inline-block;
        margin-right: 4px;
        color: #FF4222;
    }

    &-status {
        margin-top: -4px;
        color: #A8ABB3;
        font-size: 12px;
        line-height: 17px;
    }
}

@keyframes ocr-wait-rotate {
    to {
        transform: rotate(360deg);
    }
}
</style>
